import { Action, createReducer, on } from "@ngrx/store";
import { JournalViewColumn1ViewModelActions } from "../actions";
import {
  initialState,
  Column1ViewModelState,
} from "../states/column_1_view_model.states";
export const JournalViewColumn1ViewModelReducer = createReducer(
  initialState,
  on(JournalViewColumn1ViewModelActions.setGenericDocJournalListing_State, (state, action) => ({
    ...state, genericDocJournalListingState: action.genericDocJournalListingState
  })),
);
export function reducer(
  state: Column1ViewModelState | undefined,
  action: Action
) {
  return JournalViewColumn1ViewModelReducer(state, action);
}